module.exports = __webpack_public_path__ + "img/horizontal_3_2_pp2_8004.adfab29c.png";